export class UserAuthModel {
    public readonly authId: string;
    public readonly authNm: string;
  
    constructor(authId: string, authNm: string) {
      this.authId = authId;
      this.authNm = authNm;
    }
  }